import React from 'react';
import { formatNumEU, formatPct } from '../dummyData';
import { useSelector } from 'react-redux';
import { selectOverviewChartPercentage } from '../../../../store/slices/ui';
import AssetIcon from '../../../../components/AssetIcon';
import { HiddenValue } from '../ValueHideContext';

interface RankedRowsSlice {
  sym: string;
  color: string;
  value: number;
}

interface RankedRowsProps {
  data: RankedRowsSlice[];
  signed?: boolean;
}

const RankedRows: React.FC<RankedRowsProps> = ({ data, signed = false }) => {
  const isPercentage = useSelector(selectOverviewChartPercentage);

  const sorted = [...data].sort(
    (a, b) => Math.abs(b.value || 0) - Math.abs(a.value || 0),
  );

  const m = Math.max(...sorted.map((d) => Math.abs(d.value || 0))) || 1;
  const totalAbs = data.reduce((a, b) => a + Math.abs(b.value || 0), 0) || 1;

  return (
    <div className="ranked-rows-scroll no-scrollbar">
      {sorted.map((d, i) => {
        const v = d.value || 0;
        const w = (Math.abs(v) / m) * 100;
        const fill = signed ? (v >= 0 ? '#00B061' : '#F0162F') : d.color;

        let labelNode: React.ReactNode;
        if (isPercentage) {
          labelNode = formatPct(v);
        } else if (signed) {
          const text =
            (v >= 0 ? '+' : '-') + '$' + formatNumEU(Math.abs(v)).split(',')[0];
          labelNode = <HiddenValue>{text}</HiddenValue>;
        } else {
          labelNode = Math.round((Math.abs(v) / totalAbs) * 100) + '%';
        }

        return (
          <div
            key={i}
            style={{
              display: 'grid',
              gridTemplateColumns: '20px 70px 1fr 78px',
              alignItems: 'center',
              columnGap: 8,
              padding: '4px 0',
            }}
          >
            <AssetIcon
              baseAsset={d.sym}
              width={18}
              height={18}
              style={{ marginBottom: 0 }}
            />
            <span style={{ color: '#fff', fontSize: 13, fontWeight: 500 }}>
              {d.sym}
            </span>
            <div
              style={{
                height: 16,
                background: 'rgba(255,255,255,.04)',
                borderRadius: 3,
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  height: '100%',
                  width: `${w}%`,
                  background: fill,
                  borderRadius: 3,
                }}
              />
            </div>
            <span
              style={{
                color: signed ? fill : '#fff',
                fontSize: 13,
                fontVariantNumeric: 'tabular-nums',
                textAlign: 'right',
              }}
            >
              {labelNode}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default RankedRows;
